/* Maison Galba — interactions du thème */
(function () {
  'use strict';
  document.documentElement.classList.add('js');

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var pad = function (n) { n = String(n); return n.length < 2 ? '0' + n : n; };

  /* ---------- En-tête ---------- */
  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 10); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var drawer = $('[data-drawer]', header);
    var openBtn = $('[data-drawer-open]', header);
    if (!drawer || !openBtn || openBtn.dataset.bound) return;
    openBtn.dataset.bound = '1';
    var close = function () {
      drawer.hidden = true;
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      openBtn.focus();
    };
    openBtn.addEventListener('click', function () {
      drawer.hidden = false;
      openBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var first = $('a, button', drawer);
      if (first) first.focus();
    });
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer || e.target.closest('[data-drawer-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) close();
    });
  }

  /* ---------- Galerie produit : carrousel ---------- */
  function galleryGo(gallery, index, instant) {
    var track = $('[data-gallery-track]', gallery);
    var slides = $$('.gallery__slide', gallery);
    if (!track || !slides.length) return;
    var n = slides.length;
    index = ((index % n) + n) % n;
    track.scrollTo({ left: slides[index].offsetLeft, behavior: instant ? 'auto' : 'smooth' });
    galleryMark(gallery, index);
  }

  function galleryMark(gallery, index) {
    if (gallery._current === index) return;
    gallery._current = index;
    var slides = $$('.gallery__slide', gallery);
    var idx = $('[data-gallery-index]', gallery);
    if (idx) idx.textContent = pad(index + 1);
    $$('.gallery__dot', gallery).forEach(function (d, k) { d.classList.toggle('is-active', k === index); });
    var thumbs = $$('.gallery__thumb', gallery);
    thumbs.forEach(function (th, k) { th.classList.toggle('is-active', k === index); });
    var active = thumbs[index];
    var box = $('.gallery__thumbs', gallery);
    if (active && box) {
      var vertical = box.scrollHeight > box.clientHeight + 2 && getComputedStyle(box).flexDirection === 'column';
      if (vertical) box.scrollTo({ top: active.offsetTop - box.clientHeight / 2 + active.clientHeight / 2, behavior: 'smooth' });
      else box.scrollTo({ left: active.offsetLeft - box.clientWidth / 2 + active.clientWidth / 2, behavior: 'smooth' });
    }
    var zoom = $('[data-gallery-zoom]', gallery);
    if (zoom && slides[index]) zoom.href = slides[index].dataset.zoom;
    slides.forEach(function (sl, k) { sl.setAttribute('aria-hidden', k === index ? 'false' : 'true'); });
  }

  function galleryShowMedia(gallery, mediaId) {
    var slides = $$('.gallery__slide', gallery);
    for (var k = 0; k < slides.length; k++) {
      if (slides[k].dataset.mediaId === String(mediaId)) { galleryGo(gallery, k); return; }
    }
  }

  function initGallery(scope) {
    $$('[data-gallery]', scope).forEach(function (gallery) {
      if (gallery.dataset.bound) return;
      gallery.dataset.bound = '1';
      var track = $('[data-gallery-track]', gallery);
      if (!track) return;
      var slides = $$('.gallery__slide', gallery);
      gallery._current = -1;
      galleryMark(gallery, 0);
      if (slides.length < 2) return;

      /* Suivre la photo visible pendant le glissement */
      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          galleryMark(gallery, Math.max(0, Math.min(slides.length - 1, i)));
        });
      }, { passive: true });

      gallery.addEventListener('click', function (e) {
        var thumb = e.target.closest('.gallery__thumb');
        if (thumb) { galleryGo(gallery, parseInt(thumb.dataset.index, 10) - 1); stop(); return; }
        if (e.target.closest('[data-gallery-prev]')) { galleryGo(gallery, gallery._current - 1); stop(); }
        if (e.target.closest('[data-gallery-next]')) { galleryGo(gallery, gallery._current + 1); stop(); }
      });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); galleryGo(gallery, gallery._current + 1); stop(); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); galleryGo(gallery, gallery._current - 1); stop(); }
      });

      /* Glisser à la souris sur ordinateur */
      var down = false, startX = 0, startLeft = 0, moved = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
        track.style.scrollSnapType = 'none'; track.style.scrollBehavior = 'auto';
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4) moved = true;
        track.scrollLeft = startLeft - dx;
      });
      window.addEventListener('pointerup', function (e) {
        if (!down) return;
        down = false;
        track.style.scrollSnapType = ''; track.style.scrollBehavior = '';
        var dx = e.clientX - startX;
        var i = gallery._current;
        if (Math.abs(dx) > 50) i = Math.round(startLeft / track.clientWidth) + (dx < 0 ? 1 : -1);
        galleryGo(gallery, Math.max(0, Math.min(slides.length - 1, i)));
        if (moved) stop();
      });

      /* Défilement automatique */
      var delay = parseInt(gallery.dataset.autoplay, 10) || 0;
      var timer = null;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var inView = true;
      function start() {
        if (!delay || reduce || timer) return;
        timer = setInterval(function () {
          if (!inView || document.hidden || down) return;
          galleryGo(gallery, gallery._current + 1);
        }, delay);
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } gallery._stopped = true; }
      gallery.addEventListener('mouseenter', function () { if (timer) { clearInterval(timer); timer = null; } });
      gallery.addEventListener('mouseleave', function () { if (!gallery._stopped) start(); });
      track.addEventListener('touchstart', stop, { passive: true });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { inView = en[0].isIntersecting; }).observe(gallery);
      }
      if (!(window.Shopify && window.Shopify.designMode)) start();
      window.addEventListener('resize', function () { galleryGo(gallery, gallery._current, true); });
    });
  }

  /* ---------- Choix du format (variantes) ---------- */
  function initProduct(scope) {
    $$('[data-product-section]', scope).forEach(function (section) {
      if (section.dataset.bound) return;
      section.dataset.bound = '1';
      var form = $('.product-form', section);
      if (!form) return;
      var atc = $('[data-atc]', section);
      var atcLabel = $('[data-atc-label]', section);
      var atcPrice = $('[data-atc-price]', section);
      var idx = $('[data-format-index]', section);
      var sticky = $('[data-sticky-atc]', section);
      var stickyPrice = $('[data-sticky-price]', section);
      var stickyTitle = $('[data-sticky-title]', section);
      var stickyBtn = $('[data-sticky-btn]', section);
      var gallery = $('[data-gallery]', section);

      form.addEventListener('change', function (e) {
        var input = e.target;
        if (input.name !== 'id') return;
        $$('.format', form).forEach(function (f) { f.classList.toggle('is-active', f.contains(input)); });
        var available = input.dataset.available === 'true';
        if (atcPrice) atcPrice.textContent = input.dataset.price;
        if (atcLabel) atcLabel.textContent = available ? atcLabel.dataset.labelAdd : atcLabel.dataset.labelSoldout;
        if (atc) atc.disabled = !available;
        if (idx) idx.textContent = input.dataset.position;
        if (stickyPrice) stickyPrice.textContent = input.dataset.price;
        if (stickyTitle) stickyTitle.textContent = input.dataset.title;
        if (stickyBtn) stickyBtn.disabled = !available;
        if (gallery && input.dataset.mediaId) galleryShowMedia(gallery, input.dataset.mediaId);
        var qtyInput = $('[data-qty-input]', form);
        if (qtyInput) qtyInput.value = input.dataset.qty || 1;
        if (window.history.replaceState && document.body.classList.contains('template-product')) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', input.value);
          window.history.replaceState({}, '', url.toString());
        }
      });

      form.addEventListener('submit', function (e) {
        if (document.body.dataset.cartBehavior === 'page') return;
        if (!window.fetch || !window.FormData) return;
        e.preventDefault();
        addToCart(form, section);
      });

      if (sticky && atc && 'IntersectionObserver' in window) {
        var formVisible = true;
        var sectionVisible = true;
        var update = function () { sticky.hidden = formVisible || !sectionVisible; };
        new IntersectionObserver(function (entries) {
          formVisible = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;
          update();
        }).observe(atc);
        new IntersectionObserver(function (entries) {
          sectionVisible = entries[0].isIntersecting || entries[0].boundingClientRect.top < 0;
          update();
        }, { rootMargin: '0px 0px -40% 0px' }).observe(section);
      }
    });
  }

  function addToCart(form, section) {
    var buttons = $$('button[type="submit"]', section);
    var error = $('[data-form-error]', section);
    buttons.forEach(function (b) { b.setAttribute('aria-busy', 'true'); b.disabled = true; });
    if (error) error.hidden = true;

    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || 'Erreur');
        return fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { headers: { 'Accept': 'application/json' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        showToast();
      })
      .catch(function (err) {
        if (error) { error.textContent = err.message; error.hidden = false; }
      })
      .finally(function () {
        buttons.forEach(function (b) { b.removeAttribute('aria-busy'); b.disabled = false; });
        var checked = $('input[name="id"]:checked', form);
        if (checked && checked.dataset.available === 'false') buttons.forEach(function (b) { b.disabled = true; });
      });
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.remove('is-bump');
      void el.offsetWidth;
      el.classList.add('is-bump');
    });
  }

  var toastTimer;
  function showToast() {
    var toast = $('[data-toast]');
    if (!toast) return;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 4000);
  }

  /* ---------- Onglets ---------- */
  function initTabs(scope) {
    $$('[data-tabs]', scope).forEach(function (root) {
      if (root.dataset.bound) return;
      root.dataset.bound = '1';
      var tabs = $$('[role="tab"]', root);
      var select = function (tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        var media = $$('[data-tab-media]', root);
        if (media.length) {
          var own = $('[data-tab-media="' + tab.dataset.tab + '"]', root);
          media.forEach(function (m) { m.hidden = own ? m !== own : m.dataset.tabMedia !== 'default'; });
        }
        if (focus) tab.focus();
      };
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(tab); });
        tab.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
          if (e.key === 'Home') next = tabs[0];
          if (e.key === 'End') next = tabs[tabs.length - 1];
          if (next) { e.preventDefault(); select(next, true); }
        });
      });
      root.addEventListener('shopify:block:select', function (e) {
        var tab = $('[data-tab="' + (e.detail && e.detail.blockId) + '"]', root);
        if (tab) select(tab);
      });
    });
  }

  /* ---------- FAQ : une seule question ouverte ---------- */
  function initAccordions(scope) {
    $$('[data-accordion-group="single"]', scope).forEach(function (group) {
      if (group.dataset.bound) return;
      group.dataset.bound = '1';
      $$('details', group).forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          $$('details', group).forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
    });
  }

  /* ---------- Apparition au défilement ---------- */
  function initReveal(scope) {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.Shopify && window.Shopify.designMode) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    $$('.section-head, .card, .point, .split-points__media, .manifesto__main, .cta-banner__inner, .image-text__grid', scope).forEach(function (el) {
      el.classList.add('reveal');
      io.observe(el);
    });
  }

  /* ---------- Hero : inclinaison 3D ---------- */
  function initTilt(scope) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    $$('[data-tilt]', scope).forEach(function (stage) {
      if (stage.dataset.bound) return;
      stage.dataset.bound = '1';
      var depth = parseFloat(getComputedStyle(stage).getPropertyValue('--depth')) || 9;
      var frame = null;
      var target = stage.closest('.hero__media') || stage;
      var set = function (x, y) {
        stage.style.setProperty('--px', x.toFixed(3));
        stage.style.setProperty('--py', y.toFixed(3));
        stage.style.setProperty('--ry', (x * depth).toFixed(2) + 'deg');
        stage.style.setProperty('--rx', (-y * depth * 0.7).toFixed(2) + 'deg');
      };
      target.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse') return;
        var r = target.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width) * 2 - 1;
        var y = ((e.clientY - r.top) / r.height) * 2 - 1;
        stage.classList.add('is-tilting');
        if (frame) cancelAnimationFrame(frame);
        frame = requestAnimationFrame(function () { set(Math.max(-1, Math.min(1, x)), Math.max(-1, Math.min(1, y))); });
      });
      target.addEventListener('pointerleave', function () {
        stage.classList.remove('is-tilting');
        set(0, 0);
      });

      /* Mobile / tactile : léger mouvement lié au défilement */
      if (window.matchMedia('(hover: none)').matches) {
        var ticking = false;
        var onScroll = function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            var r = stage.getBoundingClientRect();
            var p = (r.top + r.height / 2) / window.innerHeight * 2 - 1;
            set(0, Math.max(-1, Math.min(1, p)) * 0.6);
            ticking = false;
          });
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }
    });
  }

  /* ---------- Barre d'annonce : un message à la fois sur téléphone ---------- */
  function initAnnouncement() {
    $$('.announcement__inner.is-scrolling').forEach(function (bar) {
      if (bar.dataset.bound) return;
      var items = $$('.announcement__item', bar);
      if (items.length < 2) return;
      bar.dataset.bound = '1';
      var mq = window.matchMedia('(max-width: 989px)');
      var i = 0, timer = null;
      var show = function () { items.forEach(function (it, k) { it.classList.toggle('is-current', k === i); }); };
      var apply = function () {
        clearInterval(timer);
        if (mq.matches) {
          bar.classList.add('is-rotating');
          show();
          timer = setInterval(function () { i = (i + 1) % items.length; show(); }, 3500);
        } else {
          bar.classList.remove('is-rotating');
        }
      };
      if (mq.addEventListener) mq.addEventListener('change', apply);
      apply();
    });
  }

  function init(scope) {
    initTilt(scope);
    initGallery(scope);
    initProduct(scope);
    initTabs(scope);
    initAccordions(scope);
    initReveal(scope);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    initAnnouncement();
    init(document);
  });

  /* Éditeur de thème : réinitialiser une section rechargée */
  document.addEventListener('shopify:section:load', function (e) {
    initHeader();
    initAnnouncement();
    init(e.target);
  });
})();
